module.exports = __webpack_public_path__ + "img/ticket_o.34c15945.svg";